import { Font } from '@react-pdf/renderer';
import { constants } from '@thecb/components';
import PublicSansRegular from 'url:../../fonts/Public-Sans-Regular.ttf';
import PublicSansSemibold from 'url:../../fonts/Public-Sans-Semibold.ttf';
import PublicSansBold from 'url:../../fonts/Public-Sans-Bold.ttf';

// https://stackoverflow.com/questions/69088511/how-to-use-custom-font-for-react-pdf-renderer

const PUBLIC_SANS = 'Public Sans';

// Font Weight 400 / Regular
Font.register({
  family: PUBLIC_SANS,
  src: PublicSansRegular,
});
// Font Weight 600 / Semi Bold
Font.register({
  family: PUBLIC_SANS,
  src: PublicSansSemibold,
});
// Font Weight 700 / Bold
Font.register({
  family: PUBLIC_SANS,
  src: PublicSansBold,
});

const sharedReportStyles = {
  page: {
    fontFamily: PUBLIC_SANS,
    padding: 32,
    fontSize: 8,
    fontWeight: constants.fontWeights.FONT_WEIGHT_REGULAR,
  },
  title: {
    fontSize: 16,
    marginBottom: 24,
    fontWeight: constants.fontWeights.FONT_WEIGHT_BOLD,
  },
  agencyHeading: {
    fontWeight: constants.fontWeights.FONT_WEIGHT_BOLD,
    fontSize: 10,
    marginBottom: 8,
  },
  heading: {
    fontWeight: constants.fontWeights.FONT_WEIGHT_SEMIBOLD,
    fontSize: 10,
    marginBottom: 8,
  },
  lineItem: {
    display: 'flex',
    flexDirection: 'row',
    marginBottom: 4,
  },
  semiBoldText: {
    fontWeight: constants.fontWeights.FONT_WEIGHT_SEMIBOLD,
  },
  boldText: {
    fontWeight: constants.fontWeights.FONT_WEIGHT_BOLD,
  },
  largeDividerGrey: {
    width: '100%',
    borderBottom: 1,
    borderColor: constants.colors.GHOST_GREY,
    margin: '16px 0px',
  },
  smallDividerGrey: {
    width: '100%',
    borderBottom: 1,
    borderColor: constants.colors.GHOST_GREY,
    margin: '8px 0px',
  },
  smallDividerBlack: {
    width: '100%',
    borderBottom: 1,
    margin: '8px 0px',
  },
  largeDividerBlack: {
    width: '100%',
    borderBottom: 1,
    marginTop: 16,
    marginBottom: 24,
  },
  clientBrandLandscape: {
    position: 'absolute',
    top: 0,
    right: 0,
    width: 130,
  },
  clientBrandPortrait: {
    position: 'absolute',
    top: 0,
    right: 0,
    height: 75,
  },
  greyContainer: {
    backgroundColor: constants.colors.ATHENS_GREY,
    padding: '8px',
    fontSize: 8,
  },
  flexContainerRow: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  stack: {
    flexDirection: 'column',
  },
  accentBackgroundColor: {
    backgroundColor: constants.colors.COOL_GREY_05,
  },
};

export default sharedReportStyles;
